"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _icons = require("@creditas/icons");

var _paginate = require("./paginate");

var _Pagination = require("./Pagination.styled");

var _core = require("@emotion/core");

const Pagination = ({
  ariaTranslations,
  current,
  maxPages,
  onChange,
  total,
  ...others
}) => (0, _core.jsx)(_Pagination.StyledPagination, others, (0, _core.jsx)(_Pagination.Item, {
  "aria-label": ariaTranslations.firstPage(),
  className: "action",
  onClick: () => onChange(1)
}, (0, _core.jsx)(_icons.Navigation.ChevronsLeft, {
  "aria-hidden": "true",
  color: "neutral07"
})), (0, _core.jsx)(_Pagination.Item, {
  "aria-label": ariaTranslations.previousPage(),
  className: "action",
  onClick: () => onChange(current === 1 ? current : current - 1)
}, (0, _core.jsx)(_icons.Navigation.ChevronLeft, {
  "aria-hidden": "true",
  color: "neutral07"
})), (0, _paginate.paginate)(current, total, maxPages).map(page => (0, _core.jsx)(_Pagination.Item, {
  "aria-label": page === current ? ariaTranslations.currentPage(page) : ariaTranslations.page(page),
  key: page,
  "data-active": page === current,
  onClick: () => onChange(page)
}, page)), (0, _core.jsx)(_Pagination.Item, {
  "aria-label": ariaTranslations.nextPage(),
  className: "action",
  onClick: () => onChange(current === total ? current : current + 1)
}, (0, _core.jsx)(_icons.Navigation.ChevronRight, {
  "aria-hidden": "true",
  color: "neutral07"
})), (0, _core.jsx)(_Pagination.Item, {
  "aria-label": ariaTranslations.lastPage(),
  className: "action",
  onClick: () => onChange(total)
}, (0, _core.jsx)(_icons.Navigation.ChevronsRight, {
  "aria-hidden": "true",
  color: "neutral07"
})));

exports.Pagination = Pagination;
Pagination.defaultProps = {
  ariaTranslations: {
    currentPage: current => `current page ${current}`,
    firstPage: () => 'first page',
    lastPage: () => 'last page',
    nextPage: () => 'next page',
    page: page => `page ${page}`,
    previousPage: () => 'previous page'
  },
  current: 1,
  disabled: false,
  maxPages: 5,
  total: 1
};
process.env.NODE_ENV !== "production" ? Pagination.propTypes = {
  ariaTranslations: (0, _propTypes.shape)({
    currentPage: _propTypes.func,
    firstPage: _propTypes.func,
    lastPage: _propTypes.func,
    nextPage: _propTypes.func,
    page: _propTypes.func,
    previousPage: _propTypes.func
  }),
  current: _propTypes.number,
  disabled: _propTypes.bool,
  maxPages: _propTypes.number,
  onChange: _propTypes.func,
  total: _propTypes.number
} : void 0;